import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Profile } from '../classes/profile';
import { IMPERSONATION_KEY } from '../common/constants';
import { ProfileService } from './profile.service';
import { RolesService } from './roles.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  impersonateRole: string;
  darkModeEnabled$: BehaviorSubject<boolean> = new BehaviorSubject(false)

  private themeConfig$ = new Subject<boolean>();
  _themeConfig = this.themeConfig$.asObservable();

  constructor(private profileService: ProfileService,
    private rolesService: RolesService) { }

    updateDarkModeEnabled(data: boolean): void {
      this.darkModeEnabled$.next(data);
    }

    getDarkModeEnabled(): Observable<boolean> {
      return this.darkModeEnabled$.asObservable();
    }

  public onThemeChanged(): Observable<boolean> {
    return this.themeConfig$.pipe();
  }

  dispatchThemeChanged(flag: boolean): void {
    this.themeConfig$.next(flag);
  }

  /*
     -There is a similar method for impersonation implemented in profile.service.
     -The method below will set the role on the fly without a page reload.
  */
  setImpersonateRole(roleKey: string): void {
    if (roleKey) {
      let _profile: Profile = this.profileService.profileObs$.getValue();
      if(roleKey === 'Driver'){
        _profile.userRoles = ['cvv_driver'];
      }
      if(roleKey === 'View'){
        _profile.userRoles = ['cvv_view_only'];
      }
      if(roleKey === 'None'){
        _profile.userRoles = [];
      }
      // console.log(_profile);
      this.profileService.setProfileObs(_profile);
      this.rolesService.setRoles(_profile.userRoles);
      localStorage.setItem(IMPERSONATION_KEY, roleKey);
    }
  }

}
